
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_44604_48055)"}},[_c('path',{attrs:{"d":"M17.416 9.999A7.916 7.916 0 019.5 17.915a7.916 7.916 0 110-15.833 7.918 7.918 0 017.916 7.917zm-7.704-5.3c-1.74 0-2.85.733-3.72 2.036a.384.384 0 00.086.519l1.108.84a.383.383 0 00.532-.068c.57-.723.961-1.143 1.83-1.143.651 0 1.458.42 1.458 1.052 0 .478-.395.724-1.039 1.085-.75.421-1.744.945-1.744 2.256v.127c0 .212.171.383.383.383h1.787a.383.383 0 00.384-.383v-.042c0-.909 2.655-.947 2.655-3.405 0-1.852-1.92-3.256-3.72-3.256zM9.5 12.617a1.47 1.47 0 00-1.469 1.469c0 .81.659 1.468 1.469 1.468a1.47 1.47 0 001.468-1.468A1.47 1.47 0 009.5 12.616z","fill":"#191F2D"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_44604_48055"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(1.583 2.082)","d":"M0 0h15.833v15.833H0z"}})])])])
          )
        }
      }
    